import styled from "styled-components";
import colors from "css/colors";

export const FormContainer = styled.div`
  flex: 1;
  margin: 10px 2em;
`;

export const Header = styled.div`
  margin: 35px 0 20px;
  padding: 0 0 8px;
  font-size: 18px;
  font-weight: 500;
  border-bottom: solid 1px ${colors.BLACK};
`;

export const Label = styled.label`
  font-weight: 600;
  font-size: 20px;
`;

export const GroupedProvince = styled.div`
  margin-bottom: 24px;
  display: inline-block;
  width: 100%;
  & .provinces > label {
    color: ${colors.GREY_DARK};
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 18px;
  }

  .provinces {
    display: flex;
    flex-direction: column;
  }
  .provinces > .ant-checkbox-wrapper {
    margin-left: 0px;
  }
`;

interface Props {
  provinceCount: number;
}
export const Container = styled.div<Props>`
  margin-top: 12px;
  column-count: ${(p: Props) => (p.provinceCount > 1 ? "2" : "1")};
`;

export const Button = styled.button`
  padding: 2px 8px;
  background: ${colors.WHITE};
  border: 1px solid ${colors.BLUE};
  color: ${colors.BLUE};
  font-size: 14px;
  border-radius: 6px;
`;

export const ClearButton = styled(Button)`
  border: 1px solid ${colors.GREY_LIGHT};
  color: ${colors.GREY_DARK};
  margin-left: 8px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Notice = styled.p`
  color: ${colors.CHARCOAL};
  font-size: 14px;
  margin-bottom: 18px;
`;
